import log from '../../logger/log.js';
import { Style, Icon, Text, Fill } from 'ol/style';

import img_poi from './img/poi.svg';
import img_taxi from './img/taxi.svg';
import img_polygon_edit_node from './img/polygon_edit_node.svg'
import client_pin from './img/client/pin.svg'
import client_circle from './img/client/circle.svg'
import img_client_pickup from './img/client/pickup.svg'
import img_client_dst from './img/client/dst.svg'
import img_client_taxi from './img/client/taxi.svg'
import img_client_location from './img/client/location.svg'
import img_client_taxi_with_client from './img/client/taxi_with_client.svg'

let poi_text_style = new Style({
    text: new Text({
        font: 'bold 14px sans-serif',
        offsetY: -48,
        //fill: new Fill({ color: 'rgb(0,0,0)' }),
        //stroke: new Stroke({ color: 'rgb(255,255,255)', width: 1 }),
        backgroundFill: new Fill({ color: 'rgb(255,255,255)' }),
        padding: [2, 0, 0, 2],
        textAlign: "center",
        textBaseline: "bottom",
        justify: "center",
    })
});

let taxi_text_style = new Style({
    text: new Text({
        font: 'bold 14px sans-serif',
        offsetY: -44,
        //fill: new Fill({ color: 'rgb(0,0,0)' }),
        //stroke: new Stroke({ color: 'rgb(255,255,255)', width: 1 }),
        backgroundFill: new Fill({ color: 'rgb(255,255,255)' }),
        padding: [2, 0, 0, 2],
        textAlign: "center",
        justify: "center",
    })
});

let client_text_style = new Style({
    text: new Text({
        font: 'bold 14px sans-serif',
        offsetY: -48,
        backgroundFill: new Fill({ color: 'rgb(255,255,255)' }),
        padding: [2, 0, 0, 2],
        textAlign: "center",
        textBaseline: "bottom",
        justify: "center",
    })
});

let poi_text_styles = {
    'poi': poi_text_style,
    'edit_poi': poi_text_style,
    'polygon_edit_node': poi_text_style,
    'taxi': taxi_text_style,
    'client_pickup': client_text_style,
    'client_dst': client_text_style,
    'client_taxi': client_text_style,
    'client_taxi_with_client': client_text_style,
    'client_taxi_arrived': client_text_style,
    'client_location': client_text_style,
}

const default_color = '#2196f3';

const poi_icon_configs = {
    poi: { 
        src: img_poi,
        anchor: [0.5, 1],
        scale: 1,
        color: default_color,
    },
    edit_poi: { 
        src: img_poi,
        anchor: [0.5, 1],
        scale: 1
    },
    polygon_edit_node: { 
        src: img_polygon_edit_node,
        anchor: [0.5, 0.5],
        scale: 0.75
    },
    taxi: { 
        src: img_taxi,
        anchor: [0.5, 1],
        scale: 1,
        color: default_color,
    },
    client_pickup: { 
        src: img_client_pickup,
        anchor: [0.5, 1],
        scale: 1,
        color: default_color,
    },
    client_dst: { 
        src: img_client_dst,
        anchor: [0.5, 1],
        scale: 1,
        color: default_color,
    },
    client_taxi: { 
        src: img_client_taxi,
        anchor: [0.5, 1],
        scale: 1,
        color: default_color,
    },
    client_taxi_with_client: { 
        src: img_client_taxi_with_client,
        anchor: [0.5, 1],
        scale: 1,
        color: default_color,
    },
    client_taxi_arrived: {
        src: img_client_dst,
        anchor: [0.5, 1],
        scale: 1,
        color: default_color,
    },
    client_location: { 
        src: img_client_location,
        anchor: [0.5, 0.5],
        scale: 0.75,
        color: default_color,
    },
};

function setIconStyles(kind, color = null) {
    const conf = poi_icon_configs[kind];
    if (!conf) return null;

    let is_client = kind.startsWith('client_');
    if(kind === 'client_location')
    {
        is_client = false;
    }

    if(is_client)
    {
        return [
            new Style({
                image: new Icon({
                    src: client_pin,
                    anchor: [ 0.5, 1],
                    color: color || conf.color,
                }),
            }),
            new Style({
                image: new Icon({
                    src: client_circle,
                    anchor: [ 0.5, 1],
                }),
            }),
            new Style({
                image: new Icon({
                    src: conf.src,
                    anchor: conf.anchor,
                    scale: conf.scale,
                    color: color || conf.color,
                }),
            })
        ]
    }
    return [
        new Style({
            image: new Icon({
                src: conf.src,
                anchor: conf.anchor,
                scale: conf.scale,
                color: color || conf.color,
            }),
        })
    ];
}

function poi_style_fun(feature, color = null)
{
    const geometry = feature.getGeometry();
    if (!geometry || geometry.getType() !== 'Point') {
        return;
    }
    let poido = feature.get("poido");

    if (!poido.kind 
        || !(poido.kind in poi_icon_configs)
        || !(poido.kind in poi_text_styles) 
        || !poido.lat 
        || !poido.lng) {
        feature.set('visible', false);
        return null;
    }

    if(poido.color) {
        color = poido.color;
    }

    let text_style = poi_text_styles[poido.kind].clone();
    if(poido.label) {
        let text = [];
        let label_list = poido.label.split("\n");
        for(let i=0; i<label_list.length; i++) {
            text.push(label_list[i]);
            text.push("12px Arial");
            if (i < label_list.length - 1)
            {
                text.push("\n");
                text.push("12px Arial");
            }
        }
        log.d(text)
        text_style.getText().setText(text);
    }

    const poi_styles = setIconStyles(poido.kind, color);

    // let zindex = poido.id;
    // text_style.setZIndex(zindex);
    // poi_style.setZIndex(zindex);
    //log.d(poido.call_number, poi_style.getZIndex());
    feature.set('visible', true);
    return [...poi_styles, text_style];
}

export { poi_style_fun };
